<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>地址</h4>
        <span class="f-s-14 c-m-l-15">管理业务中涉及到的地址信息</span>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入地址"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增地址</el-button>
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport({
              'fpi-regex:name|string#or': searchValue,
              'fpi-regex:phone|string#or': searchValue,
              'fpi-regex:_id|string#or': searchValue,
              beanName: 'address',
              title: '地址列表'
            })
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          height="calc(100% - 50px)"
          :data="fpi.data"
          ref="table"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="150" label="操作">
            <template slot-scope="scope">
              <el-button @click.native.prevent="doEdit(scope.row)" size="mini">编辑</el-button>
              <template v-if="scope.row.state == 0">
                <el-button
                  @click.native.prevent="doEnable(scope.row._id)"
                  type="danger"
                  size="mini"
                >
                  已禁用
                </el-button>
              </template>
              <template v-else>
                <el-button
                  @click.native.prevent="doDisable(scope.row._id)"
                  type="success"
                  size="mini"
                >
                  已启用
                </el-button>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="地址" width="100" fixed>
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="$router.push({ path: `/Address/${scope.row._id}` })"
                type="text"
              >
                {{ scope.row.address }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            prop="longitude"
            label="经度"
            min-width="100px"
            sortable
          ></el-table-column>
          <el-table-column
            prop="dimension"
            label="纬度"
            min-width="100px"
            sortable
          ></el-table-column>
          <el-table-column
            prop="addressType"
            label="地址类型"
            :formatter="formatAddressType"
            min-width="100px"
          ></el-table-column>
          <el-table-column
            prop="addressDescription"
            label="地址说明"
            min-width="150px"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="accuracy"
            label="地理编码准确度"
            min-width="120px"
          ></el-table-column>
          <el-table-column
            prop="locationType"
            label="位置类型"
            :formatter="formatLocationType"
            min-width="100px"
          ></el-table-column>
          <el-table-column prop="zipCode" label="邮编" min-width="80px" sortable></el-table-column>
          <el-table-column prop="streetName" label="街道地址" min-width="150px"></el-table-column>
          <el-table-column prop="timeZone" label="时区" min-width="60px"></el-table-column>
          <template v-for="(item, i) in extFields">
            <el-table-column
              :prop="'exts.' + item.name"
              :label="item.nameDisp"
              :key="i"
              width="100px"
              show-overflow-tooltip
            ></el-table-column>
          </template>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="地址信息" :visible.sync="openDetail">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="110px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="地址名称" prop="address">
          <el-input
            v-model="formData.address"
            suffix-icon="el-icon-office-building"
            @blur="getGeocode"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="省市区"
          prop="area"
          :rules="{
            required: true,
            type: 'array',
            trigger: 'blur',
            message: '省市区不能为空'
          }"
        >
          <el-cascader
            :options="area.options"
            :props="area.props"
            v-model="formData.area"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="经度" prop="longitude">
          <el-input v-model="formData.longitude" disabled placeholder="根据地址自动生成"></el-input>
        </el-form-item>
        <el-form-item label="维度" prop="dimension">
          <el-input v-model="formData.dimension" disabled placeholder="根据地址自动生成"></el-input>
        </el-form-item>
        <el-form-item label="地址类型" prop="addressType">
          <el-select v-model="formData.addressType">
            <el-option
              v-for="item in options.addressType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址说明" prop="addressDescription">
          <el-input v-model="formData.addressDescription"></el-input>
        </el-form-item>
        <el-form-item label="地理编码准确度" prop="accuracy">
          <el-input v-model="formData.accuracy"></el-input>
        </el-form-item>
        <el-form-item label="位置类型" prop="locationType">
          <el-select v-model="formData.locationType">
            <el-option
              v-for="item in options.locationType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮编" prop="zipCode">
          <el-input v-model="formData.zipCode"></el-input>
        </el-form-item>
        <el-form-item label="国家" prop="country">
          <el-input v-model="formData.country"></el-input>
        </el-form-item>
        <el-form-item label="街道地址" prop="streetName">
          <el-input v-model="formData.streetName"></el-input>
        </el-form-item>
        <el-form-item label="时区" prop="timeZone">
          <el-input v-model="formData.timeZone"></el-input>
        </el-form-item>
        <el-form-item
          v-for="(extField, idx) in extFields"
          :prop="'exts.' + extField.name"
          :key="idx"
          :label="extField.nameDisp"
        >
          <template
            v-if="
              extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
            "
          >
            <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
          </template>
          <template v-if="extField.type == 'radio'">
            <el-radio-group v-model="formData.exts[extField.name]">
              <el-radio
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </el-radio-group>
          </template>
          <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
            <el-checkbox-group v-model="formData.exts[extField.name]">
              <el-checkbox
                v-for="item in options[extField.valueOption]"
                :label="item.value"
                :key="item.value"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </template>
          <template v-if="extField.type == 'select'">
            <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
              <el-option
                v-for="item in options[extField.valueOption]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-if="extField.type == 'cascade'">
            <el-cascader
              clearable
              v-model="formData.exts[extField.name]"
              :options="options[extField.valueOption]"
              :props="{ checkStrictly: true, label: 'name' }"
            ></el-cascader>
          </template>
          <template v-if="extField.type == 'time'">
            <el-time-select
              v-model="formData.exts[extField.name]"
              placeholder="选择时间"
            ></el-time-select>
          </template>
          <template v-if="extField.type == 'date' || extField.type == 'datetime'">
            <el-date-picker
              v-model="formData.exts[extField.name]"
              :type="extField.type"
              placeholder="选择日期"
            ></el-date-picker>
          </template>
          <template v-if="extField.type == 'switch'">
            <el-switch
              v-model="formData.exts[extField.name]"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
            ></el-switch>
          </template>
          <template v-if="extField.type == 'rate'">
            <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'contacts',
  data() {
    window.$this = this;
    return {
      refresh: true,
      name: 'address',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {},
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_addressType: { codeId: 'ADDRESSTYPE' },
        codecfg_locationType: { codeId: 'LOCATIONTYPE' }
      },
      //地址级联-懒加载
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true
        }
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('address', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    formatState(row, column, cellValue) {
      if (cellValue == 0) return '无效';
      else if (cellValue == 1) return '有效';
      else return '未知';
    },
    formatAddressType(row, column, cellValue) {
      return this.osg.codelabel('addressType', cellValue);
    },
    formatLocationType(row, column, cellValue) {
      return this.osg.codelabel('locationType', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:address|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/address/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      /*渲染省市区*/
      var area = [];
      if (row.province) {
        area[0] = row.province;
      }
      if (row.city) {
        area[1] = row.city;
      }
      if (row.district) {
        area[2] = row.district;
      }
      row.area = area;
      this.$util.renderExtField(this.extFields, row);
      this.formData = row;
      this.openDetail = true;
    },
    doSave() {
      var params = this.$util.deepCopy(this.formData);
      params.area = params.area || [];
      params.province = params.area[0] || '';
      params.city = params.area[1] || '';
      params.district = params.area[2] || '';
      // // delete params.area;
      this.$util.saveExtField(this.extFields, params);
      if (this.osg.validate()) {
        this.osg.ajax('basic/address/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/address/enable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/address/disable/' + id + '.do', null, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //获取地理编码
    async getGeocode() {
      if (this.formData.area[0] && this.formData.area[1]) {
        var citys = await this.$util.getCity(this.formData.area[0]);
        var cityName = '';
        for (var city of citys) {
          if (city._id == this.formData.area[1]) {
            cityName = city.name;
            break;
          }
        }
        this.osg.geocode(cityName + this.formData.address, res => {
          this.formData.longitude = res.location.split(',')[0];
          this.formData.dimension = res.location.split(',')[1];
          this.$forceUpdate();
        });
      }
    }
  }
};
</script>
